// extracted by mini-css-extract-plugin
export default {"root":"FooterContent_root__SbzWu","addremove":"FooterContent_addremove__SWypn","placeHolderShimmer":"FooterContent_placeHolderShimmer__xKDTC"};